import { useState, useEffect } from 'react';
import { detectPlatform, getAppStoreUrl } from '../utils/platformDetect';
import './AppPrompt.css';

/**
 * 앱 다운로드 프롬프트 컴포넌트
 * 모바일에서만 표시되며 사용자가 닫을 수 있음
 */
export default function AppPrompt() {
  const [isVisible, setIsVisible] = useState(false);
  const [platform, setPlatform] = useState(null);
  const [appStoreUrl, setAppStoreUrl] = useState(null);

  useEffect(() => {
    const detectedPlatform = detectPlatform();
    setPlatform(detectedPlatform);

    // 모바일이면서 이전에 닫지 않았으면 표시
    if (detectedPlatform === 'ios' || detectedPlatform === 'android') {
      const dismissed = sessionStorage.getItem('app_prompt_dismissed');
      if (!dismissed) {
        setIsVisible(true);
        setAppStoreUrl(getAppStoreUrl());
      }
    }
  }, []);

  const handleOpenApp = () => {
    if (appStoreUrl) {
      window.location.href = appStoreUrl;
    }
  };

  const handleDismiss = () => {
    setIsVisible(false);
    sessionStorage.setItem('app_prompt_dismissed', 'true');
  };

  // 모바일이 아니거나 닫힌 상태면 표시 안 함
  if (!isVisible || platform === 'desktop') {
    return null;
  }

  return (
    <div className="app-prompt">
      <div className="app-prompt-content">
        <div className="app-prompt-title">
          📱 EduStaff 앱에서 보기
        </div>
        <div className="app-prompt-desc">
          앱에서 더 편리하게 이용하세요
        </div>
      </div>
      <div className="app-prompt-buttons">
        <button className="btn-dismiss" onClick={handleDismiss}>
          닫기
        </button>
        <button className="btn-app-download" onClick={handleOpenApp}>
          {platform === 'android' ? 'Play Store' : 'App Store'}
        </button>
      </div>
    </div>
  );
}
